module.exports = __webpack_public_path__ + "img/FlagForIncorrectAnswer.f23571da.svg";